module.exports = __webpack_public_path__ + "static/media/scroll-icon.6a175770.svg";